import { Avatar, Card, Grid, Typography } from '@mui/material';
import SVLabeledText from './SVLabeledText';
import { SVSummaryCardItem } from '@/types/common';

type SVSummaryCardProps = {
  label: string;
  items: SVSummaryCardItem[];
  avatar?: string | null;
  hideCardStyle?: boolean;
};

export default function SVSummaryCard({
  label,
  items,
  avatar,
  hideCardStyle = false,
}: SVSummaryCardProps) {
  return (
    <Card
      sx={hideCardStyle ? { border: 'none' } : undefined}
      elevation={hideCardStyle ? 0 : 1}>
      <Typography variant="h5" mb={2}>
        {label}
      </Typography>
      <Grid spacing={2} container>
        <Grid container spacing={2} size={{ xs: 12, md: !avatar ? 12 : 9 }}>
          {items.map(item => {
            const {
              text,
              customContent,
              label,
              size = { xs: 12, md: 6, lg: 4, xl: 3 },
            } = item;
            if (!text && text !== 0 && !customContent) {
              return null;
            }

            return (
              <Grid key={label} size={size}>
                <SVLabeledText {...item} />
              </Grid>
            );
          })}
        </Grid>
        {avatar && (
          <Grid size={{ xs: 12, md: 3 }}>
            <Avatar sx={{ height: 160, width: 160 }} src={avatar || ''} />
          </Grid>
        )}
      </Grid>
    </Card>
  );
}
